// api/projections/v1/projections.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file projections/v1/projections.proto (package projections.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file projections/v1/projections.proto.
 */
export const file_projections_v1_projections: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Definition messages
 *
 * @generated from message projections.v1.ProjectionDef
 */
export type ProjectionDef = Message<"projections.v1.ProjectionDef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: projections.v1.IdentityDef identity = 5;
   */
  identity?: IdentityDef | undefined;

  /**
   * @generated from field: repeated projections.v1.SourceDef sources = 6;
   */
  sources: SourceDef[];
};

/**
 * Describes the message projections.v1.ProjectionDef.
 * Use `create(ProjectionDefSchema)` to create a new message.
 */
export const ProjectionDefSchema: GenMessage<ProjectionDef> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 0);

/**
 * @generated from message projections.v1.IdentityDef
 */
export type IdentityDef = Message<"projections.v1.IdentityDef"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message projections.v1.IdentityDef.
 * Use `create(IdentityDefSchema)` to create a new message.
 */
export const IdentityDefSchema: GenMessage<IdentityDef> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 1);

/**
 * @generated from message projections.v1.SourceDef
 */
export type SourceDef = Message<"projections.v1.SourceDef"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * create, update, upsert, delete
   *
   * @generated from field: string operation = 2;
   */
  operation: string;

  /**
   * @generated from field: string identity_expr = 3;
   */
  identityExpr: string;

  /**
   * @generated from field: string condition = 4;
   */
  condition: string;

  /**
   * @generated from field: map<string, string> mappings = 5;
   */
  mappings: { [key: string]: string };
};

/**
 * Describes the message projections.v1.SourceDef.
 * Use `create(SourceDefSchema)` to create a new message.
 */
export const SourceDefSchema: GenMessage<SourceDef> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 2);

/**
 * @generated from message projections.v1.GetDefinitionRequest
 */
export type GetDefinitionRequest = Message<"projections.v1.GetDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message projections.v1.GetDefinitionRequest.
 * Use `create(GetDefinitionRequestSchema)` to create a new message.
 */
export const GetDefinitionRequestSchema: GenMessage<GetDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 3);

/**
 * @generated from message projections.v1.GetDefinitionResponse
 */
export type GetDefinitionResponse = Message<"projections.v1.GetDefinitionResponse"> & {
  /**
   * @generated from field: projections.v1.ProjectionDef definition = 1;
   */
  definition?: ProjectionDef | undefined;
};

/**
 * Describes the message projections.v1.GetDefinitionResponse.
 * Use `create(GetDefinitionResponseSchema)` to create a new message.
 */
export const GetDefinitionResponseSchema: GenMessage<GetDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 4);

/**
 * @generated from message projections.v1.CreateDefinitionRequest
 */
export type CreateDefinitionRequest = Message<"projections.v1.CreateDefinitionRequest"> & {
  /**
   * @generated from field: projections.v1.ProjectionDef definition = 1;
   */
  definition?: ProjectionDef | undefined;
};

/**
 * Describes the message projections.v1.CreateDefinitionRequest.
 * Use `create(CreateDefinitionRequestSchema)` to create a new message.
 */
export const CreateDefinitionRequestSchema: GenMessage<CreateDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 5);

/**
 * @generated from message projections.v1.CreateDefinitionResponse
 */
export type CreateDefinitionResponse = Message<"projections.v1.CreateDefinitionResponse"> & {
  /**
   * @generated from field: projections.v1.ProjectionDef definition = 1;
   */
  definition?: ProjectionDef | undefined;
};

/**
 * Describes the message projections.v1.CreateDefinitionResponse.
 * Use `create(CreateDefinitionResponseSchema)` to create a new message.
 */
export const CreateDefinitionResponseSchema: GenMessage<CreateDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 6);

/**
 * @generated from message projections.v1.UpdateDefinitionRequest
 */
export type UpdateDefinitionRequest = Message<"projections.v1.UpdateDefinitionRequest"> & {
  /**
   * @generated from field: projections.v1.ProjectionDef definition = 1;
   */
  definition?: ProjectionDef | undefined;
};

/**
 * Describes the message projections.v1.UpdateDefinitionRequest.
 * Use `create(UpdateDefinitionRequestSchema)` to create a new message.
 */
export const UpdateDefinitionRequestSchema: GenMessage<UpdateDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 7);

/**
 * @generated from message projections.v1.UpdateDefinitionResponse
 */
export type UpdateDefinitionResponse = Message<"projections.v1.UpdateDefinitionResponse"> & {
  /**
   * @generated from field: projections.v1.ProjectionDef definition = 1;
   */
  definition?: ProjectionDef | undefined;
};

/**
 * Describes the message projections.v1.UpdateDefinitionResponse.
 * Use `create(UpdateDefinitionResponseSchema)` to create a new message.
 */
export const UpdateDefinitionResponseSchema: GenMessage<UpdateDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 8);

/**
 * @generated from message projections.v1.DeleteDefinitionRequest
 */
export type DeleteDefinitionRequest = Message<"projections.v1.DeleteDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message projections.v1.DeleteDefinitionRequest.
 * Use `create(DeleteDefinitionRequestSchema)` to create a new message.
 */
export const DeleteDefinitionRequestSchema: GenMessage<DeleteDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 9);

/**
 * @generated from message projections.v1.DeleteDefinitionResponse
 */
export type DeleteDefinitionResponse = Message<"projections.v1.DeleteDefinitionResponse"> & {
};

/**
 * Describes the message projections.v1.DeleteDefinitionResponse.
 * Use `create(DeleteDefinitionResponseSchema)` to create a new message.
 */
export const DeleteDefinitionResponseSchema: GenMessage<DeleteDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 10);

/**
 * @generated from message projections.v1.ListDefinitionsRequest
 */
export type ListDefinitionsRequest = Message<"projections.v1.ListDefinitionsRequest"> & {
};

/**
 * Describes the message projections.v1.ListDefinitionsRequest.
 * Use `create(ListDefinitionsRequestSchema)` to create a new message.
 */
export const ListDefinitionsRequestSchema: GenMessage<ListDefinitionsRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 11);

/**
 * @generated from message projections.v1.ListDefinitionsResponse
 */
export type ListDefinitionsResponse = Message<"projections.v1.ListDefinitionsResponse"> & {
  /**
   * @generated from field: repeated projections.v1.ProjectionDef definitions = 1;
   */
  definitions: ProjectionDef[];
};

/**
 * Describes the message projections.v1.ListDefinitionsResponse.
 * Use `create(ListDefinitionsResponseSchema)` to create a new message.
 */
export const ListDefinitionsResponseSchema: GenMessage<ListDefinitionsResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 12);

/**
 * Projection query messages
 *
 * @generated from message projections.v1.GetRequest
 */
export type GetRequest = Message<"projections.v1.GetRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message projections.v1.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 13);

/**
 * @generated from message projections.v1.GetResponse
 */
export type GetResponse = Message<"projections.v1.GetResponse"> & {
  /**
   * @generated from field: projections.v1.Projection projection = 1;
   */
  projection?: Projection | undefined;
};

/**
 * Describes the message projections.v1.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 14);

/**
 * @generated from message projections.v1.QueryRequest
 */
export type QueryRequest = Message<"projections.v1.QueryRequest"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: map<string, string> filters = 2;
   */
  filters: { [key: string]: string };

  /**
   * @generated from field: string order_by = 3;
   */
  orderBy: string;

  /**
   * @generated from field: bool descending = 4;
   */
  descending: boolean;

  /**
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 6;
   */
  offset: number;
};

/**
 * Describes the message projections.v1.QueryRequest.
 * Use `create(QueryRequestSchema)` to create a new message.
 */
export const QueryRequestSchema: GenMessage<QueryRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 15);

/**
 * @generated from message projections.v1.QueryResponse
 */
export type QueryResponse = Message<"projections.v1.QueryResponse"> & {
  /**
   * @generated from field: repeated projections.v1.Projection projections = 1;
   */
  projections: Projection[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message projections.v1.QueryResponse.
 * Use `create(QueryResponseSchema)` to create a new message.
 */
export const QueryResponseSchema: GenMessage<QueryResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 16);

/**
 * @generated from message projections.v1.GetWithGraphRequest
 */
export type GetWithGraphRequest = Message<"projections.v1.GetWithGraphRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 depth = 2;
   */
  depth: number;
};

/**
 * Describes the message projections.v1.GetWithGraphRequest.
 * Use `create(GetWithGraphRequestSchema)` to create a new message.
 */
export const GetWithGraphRequestSchema: GenMessage<GetWithGraphRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 17);

/**
 * @generated from message projections.v1.GetWithGraphResponse
 */
export type GetWithGraphResponse = Message<"projections.v1.GetWithGraphResponse"> & {
  /**
   * @generated from field: projections.v1.Projection root = 1;
   */
  root?: Projection | undefined;

  /**
   * @generated from field: map<string, projections.v1.Projection> related = 2;
   */
  related: { [key: string]: Projection };

  /**
   * @generated from field: repeated projections.v1.GraphEdge edges = 3;
   */
  edges: GraphEdge[];
};

/**
 * Describes the message projections.v1.GetWithGraphResponse.
 * Use `create(GetWithGraphResponseSchema)` to create a new message.
 */
export const GetWithGraphResponseSchema: GenMessage<GetWithGraphResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 18);

/**
 * @generated from message projections.v1.Projection
 */
export type Projection = Message<"projections.v1.Projection"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * JSON
   *
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated string event_ids = 7;
   */
  eventIds: string[];
};

/**
 * Describes the message projections.v1.Projection.
 * Use `create(ProjectionSchema)` to create a new message.
 */
export const ProjectionSchema: GenMessage<Projection> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 19);

/**
 * @generated from message projections.v1.GraphEdge
 */
export type GraphEdge = Message<"projections.v1.GraphEdge"> & {
  /**
   * @generated from field: string from_id = 1;
   */
  fromId: string;

  /**
   * @generated from field: string to_id = 2;
   */
  toId: string;

  /**
   * @generated from field: string relation_type = 3;
   */
  relationType: string;

  /**
   * @generated from field: string via_event_id = 4;
   */
  viaEventId: string;
};

/**
 * Describes the message projections.v1.GraphEdge.
 * Use `create(GraphEdgeSchema)` to create a new message.
 */
export const GraphEdgeSchema: GenMessage<GraphEdge> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 20);

/**
 * @generated from message projections.v1.RebuildRequest
 */
export type RebuildRequest = Message<"projections.v1.RebuildRequest"> & {
  /**
   * @generated from field: string projection_type = 1;
   */
  projectionType: string;
};

/**
 * Describes the message projections.v1.RebuildRequest.
 * Use `create(RebuildRequestSchema)` to create a new message.
 */
export const RebuildRequestSchema: GenMessage<RebuildRequest> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 21);

/**
 * @generated from message projections.v1.RebuildResponse
 */
export type RebuildResponse = Message<"projections.v1.RebuildResponse"> & {
  /**
   * @generated from field: int32 rebuilt_count = 1;
   */
  rebuiltCount: number;
};

/**
 * Describes the message projections.v1.RebuildResponse.
 * Use `create(RebuildResponseSchema)` to create a new message.
 */
export const RebuildResponseSchema: GenMessage<RebuildResponse> = /*@__PURE__*/
  messageDesc(file_projections_v1_projections, 22);

/**
 * @generated from service projections.v1.ProjectionService
 */
export const ProjectionService: GenService<{
  /**
   * Definition management
   *
   * @generated from rpc projections.v1.ProjectionService.GetDefinition
   */
  getDefinition: {
    methodKind: "unary";
    input: typeof GetDefinitionRequestSchema;
    output: typeof GetDefinitionResponseSchema;
  },
  /**
   * @generated from rpc projections.v1.ProjectionService.CreateDefinition
   */
  createDefinition: {
    methodKind: "unary";
    input: typeof CreateDefinitionRequestSchema;
    output: typeof CreateDefinitionResponseSchema;
  },
  /**
   * @generated from rpc projections.v1.ProjectionService.UpdateDefinition
   */
  updateDefinition: {
    methodKind: "unary";
    input: typeof UpdateDefinitionRequestSchema;
    output: typeof UpdateDefinitionResponseSchema;
  },
  /**
   * @generated from rpc projections.v1.ProjectionService.DeleteDefinition
   */
  deleteDefinition: {
    methodKind: "unary";
    input: typeof DeleteDefinitionRequestSchema;
    output: typeof DeleteDefinitionResponseSchema;
  },
  /**
   * @generated from rpc projections.v1.ProjectionService.ListDefinitions
   */
  listDefinitions: {
    methodKind: "unary";
    input: typeof ListDefinitionsRequestSchema;
    output: typeof ListDefinitionsResponseSchema;
  },
  /**
   * Projection queries
   *
   * @generated from rpc projections.v1.ProjectionService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * @generated from rpc projections.v1.ProjectionService.Query
   */
  query: {
    methodKind: "unary";
    input: typeof QueryRequestSchema;
    output: typeof QueryResponseSchema;
  },
  /**
   * @generated from rpc projections.v1.ProjectionService.GetWithGraph
   */
  getWithGraph: {
    methodKind: "unary";
    input: typeof GetWithGraphRequestSchema;
    output: typeof GetWithGraphResponseSchema;
  },
  /**
   * Rebuild
   *
   * @generated from rpc projections.v1.ProjectionService.Rebuild
   */
  rebuild: {
    methodKind: "unary";
    input: typeof RebuildRequestSchema;
    output: typeof RebuildResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_projections_v1_projections, 0);

